/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiEntitySchemaFieldFeature
 */
export interface InternalApiEntitySchemaFieldFeature {
    /**
     * 
     * @type {InternalApiEntitySchemaFieldFeatureTypeEnum}
     * @memberof InternalApiEntitySchemaFieldFeature
     */
    type: InternalApiEntitySchemaFieldFeatureTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiEntitySchemaFieldFeature
     */
    entities: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum InternalApiEntitySchemaFieldFeatureTypeEnum {
    SCENARIOS = 'SCENARIOS'
}


/**
 * Check if a given object implements the InternalApiEntitySchemaFieldFeature interface.
 */
export function instanceOfInternalApiEntitySchemaFieldFeature(value: object): value is InternalApiEntitySchemaFieldFeature {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('entities' in value) || value['entities'] === undefined) return false;
    return true;
}

export function InternalApiEntitySchemaFieldFeatureFromJSON(json: any): InternalApiEntitySchemaFieldFeature {
    return InternalApiEntitySchemaFieldFeatureFromJSONTyped(json, false);
}

export function InternalApiEntitySchemaFieldFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiEntitySchemaFieldFeature {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'entities': json['entities'],
    };
}

export function InternalApiEntitySchemaFieldFeatureToJSON(json: any): InternalApiEntitySchemaFieldFeature {
    return InternalApiEntitySchemaFieldFeatureToJSONTyped(json, false);
}

export function InternalApiEntitySchemaFieldFeatureToJSONTyped(value?: InternalApiEntitySchemaFieldFeature | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'entities': value['entities'],
    };
}

